import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './aprovar-banner.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Stack,
  Checkbox,
  Tooltip,
  IconButton,
  Spinner,
  RadioGroup,
  Radio,
  Wrap,
  TagLabel,
  TagCloseButton,
  Tag,
  WrapItem,
} from '@chakra-ui/react';
import * as api from '../../../../api/banner';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { MdInfoOutline } from 'react-icons/md';
import { ImageDropzoneDisabled } from '../../../../components/common/imageDropzoneDisabled/imageDropzoneDisabled';
import * as apiPendencia from '../../../../api/pendencia';
import { listarExecutores } from '../../../../api/noticia';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const AprovarBanner: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    dataFim: { value: ''; error: boolean };
    imagem: { value: string; error: boolean };
    urlBanner: { value: string; error: boolean };
    creditoAutorImagem: { value: string; error: boolean };
    descricaoImagem: { value: string; error: boolean };
    ordemBanner: { value: any[]; error: boolean };
    categoriaId: { value: string; error: boolean };
    paginaId: { value: any[]; error: boolean };
    exigeAprovacao: { value: number; error: boolean };
    usuarioId: { value: any; error: boolean };
  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    dataFim: { value: '', error: false },
    imagem: { value: '', error: false },
    urlBanner: { value: '', error: false },
    creditoAutorImagem: { value: '', error: false },
    descricaoImagem: { value: '', error: false },
    ordemBanner: { value: [], error: false },
    categoriaId: { value: '', error: false },
    paginaId: { value: [], error: false },
    exigeAprovacao: { value: 0, error: false },
    usuarioId: { value: null, error: false },

  });

  const [imageBase64, setImageBase64] = useState<string>('');
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [ordem, setOrdem] = useState<any[]>([]);
  const [paginaAtiva, setPaginaAtiva] = useState<any[]>([]);
  const [paginas, setPaginas] = useState<any[]>([]);
  const [ordemValida, setOrdemValida] = useState(true);
  const [ordemRecomendada, setOrdemRecomendada] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedPages, setSelectedPages] = useState<number[]>([]);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [removedPages, setRemovedPages] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [aprovadores, setAprovadores] = useState<any[]>([]);
  const [selectedUser, setSelectedUser] = useState<number | null>(null);
  const [executor, setExecutor] = useState<any[]>([]);
  const [isReprovandoButton, setReprovandoButton] = useState<boolean>(false);
  const [isAprovandoButton, setAprovandoButton] = useState<boolean>(false);
  const [tagUsuario, setTagUsuario] = useState<string>('');
  const [inputValueTagUsuario, setInputValueTagUsuario] = useState('');

  const fetchBannerData = async () => {
    setIsLoading(true);
    try {
      const bannerData = await api.obterBanner(Number(id));
      const { nomePublicacao, datPublicacao, datDespublicar, dscCreditoImagem, seqCategoria, conteudoPaginaDTO, binPublicacao, urlBin, pendencia, dscCitacaoUsuario } = bannerData;

      setExecutor(bannerData.pendencia.seqExecutor)

      const paginas = conteudoPaginaDTO.map((item: any) => item.seqPagina);
      const ordens = conteudoPaginaDTO.map((item: any) => item.numOrdem);

      let exigeAprovacaoValue = 0;

      if (pendencia && pendencia.seqSolicitante) {
        exigeAprovacaoValue = 1;
        setSelectedUser(pendencia.seqExecutor);
      }
      const usuarioIdValue = pendencia?.seqExecutor;

      const userTagsArray = (dscCitacaoUsuario || '')
        .split(' ')
        .filter((tag: any) => tag.startsWith('@'));
      setTagUsuario(userTagsArray.join(' '));

      setFormValues({
        titulo: { value: nomePublicacao, error: false },
        data: { value: datPublicacao || today, error: false },
        dataFim: { value: datDespublicar || '', error: false },
        imagem: { value: binPublicacao || '', error: false },
        urlBanner: { value: urlBin || '', error: false },
        creditoAutorImagem: { value: dscCreditoImagem || '', error: false },
        descricaoImagem: { value: '', error: false },
        ordemBanner: {
          value: conteudoPaginaDTO.map((item: any) => ({
            seqPagina: item.seqPagina,
            numOrdem: item.numOrdem,
          })), error: false
        },
        categoriaId: { value: seqCategoria.toString(), error: false },
        paginaId: { value: paginas, error: false },
        exigeAprovacao: { value: exigeAprovacaoValue, error: false },
        usuarioId: { value: usuarioIdValue || '', error: false },
      });

      if (conteudoPaginaDTO) {
        setOrdem(conteudoPaginaDTO[0].numOrdem);
        setPaginaAtiva(conteudoPaginaDTO[0].seqPagina);
      }
    } catch (error) {
      console.error("Erro ao buscar dados do banner:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await listarExecutores();
      setAprovadores(data);
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    fetchBannerData();
    fetchCategorias();
    fetchAprovadoresAtivos();
    fetchPaginas();
  }, []);

  const fetchPaginas = async () => {
    try {
      const data = await api.paginasAtivas();
      setPaginas(data);
    } catch (error) {
      console.error('Erro ao buscar páginas ativas:', error);
    }
  };

  const handleReprovarPublicacao = async () => {

    const { usuarioId } = formValues;

    const motivoReprovacao = await Swal.fire({
      input: 'textarea',
      width: '50%',
      title: 'Qual é o motivo da reprovação?',
      inputPlaceholder: 'Digite o motivo da reprovação aqui',
      inputAttributes: {
        'aria-label': 'Digite o motivo da reprovação aqui'
      },
      reverseButtons: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Enviar Motivo',
      confirmButtonColor: '#1665D8',
      cancelButtonColor: '#EDF2F7',
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        if (confirmButton) {
          confirmButton.disabled = true;
          const input = Swal.getInput();
          if (input) {
            input.addEventListener('input', () => {
              confirmButton.disabled = input.value.trim().length < 1;
            });
          }
        }
      },
    });

    if (motivoReprovacao.isConfirmed) {
      setReprovandoButton(true);
      const params = {
        pendencia: {
          codPendencia: 1,
          seqSolicitante: seqUsuario,
          seqExecutor: usuarioId.value,
          dscObs: motivoReprovacao.value,
        }
      };

      try {
        await apiPendencia.reprovarConteudo(Number(id), params);
        setReprovandoButton(false);
        await Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'A publicação foi reprovada com sucesso.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      } catch (error) {
        setReprovandoButton(false);
        console.error('Erro ao reprovar publicação:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: 'Ocorreu um erro ao reprovar a publicação. Tente novamente.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      }
    }
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setAprovandoButton(true);

    const params = Number(id);

    try {
      await apiPendencia.aprovarConteudo(params);
      setAprovandoButton(false);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Publicação aprovada com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      });
    } catch (error) {
      setAprovandoButton(false);
      console.error('Erro ao aprovar publicação:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao aprovar publicação. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      });
    }
  };

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Aprovar Banner
      </Heading>
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <Box m="40px 0" w="100%">
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Categoria do Banner</FormLabel>
                  <Select
                    disabled={true}
                    placeholder='Selecione uma Categoria'
                    borderColor="gray.300"
                    _hover={{ borderColor: 'blue.500' }}
                    value={formValues.categoriaId.value}
                    className='opacidade'
                  >
                    {categorias.length > 0 ? (
                      categorias.map(categoria => (
                        <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                          {categoria.dscCategoria}
                        </option>
                      ))
                    ) : (
                      <option disabled>Sem categorias disponíveis</option>
                    )}
                  </Select>
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Título da Publicação</FormLabel>
                  <CustomInput
                    isDisabled={true}
                    className='opacidade'
                    value={formValues.titulo.value}
                  />
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl>
                  <FormLabel mb="8px">URL para tornar banner clicável</FormLabel>
                  <CustomInput
                    isDisabled={true}
                    className='opacidade'
                    value={formValues.urlBanner.value}
                  />
                </FormControl>
              </div>

              <div className="col-md-3 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Data para Publicação</FormLabel>
                  <CustomInput
                    isDisabled={true}
                    className='opacidade'
                    id="banner-approve-publication-date"
                    type="date"
                    value={formValues.data.value}
                    min={today}
                  />
                </FormControl>
              </div>
              <div className="col-md-3 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Data fim para Publicação</FormLabel>
                  <CustomInput
                    isDisabled={true}
                    className='opacidade'
                    id="banner-approve-unpublish-date"
                    type="date"
                    value={formValues.dataFim.value}
                    min={today}
                  />
                </FormControl>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Imagem do Banner</FormLabel>
                  <ImageDropzoneDisabled
                    base64={formValues.imagem.value || ''}
                    width={1200}
                    height={400}
                  />
                </FormControl>
              </div>
            </div>
            <div className="row">

              <div className="col-md-6 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Tags</FormLabel>
                </FormControl>
                <div className="rolagem-hashtag mb-2">
                  {tagUsuario && tagUsuario.trim().length > 0 ? (
                    <Wrap spacing="2px">
                      {tagUsuario.split(" ").map((tag, index) => (
                        <WrapItem key={index}>
                          <Tooltip label={tag} placement="top" hasArrow>
                            <Tag variant="solid" colorScheme="blue" maxW="180px" isTruncated>
                              <TagLabel>{tag}</TagLabel>
                            </Tag>
                          </Tooltip>
                        </WrapItem>
                      ))}
                    </Wrap>
                  ) : (
                    <p>Não há tags</p>
                  )}
                </div>

                <FormControl>
                  <Flex justify="space-between" align="center" mb="8px">
                    <FormLabel mb="8px">
                      Escolha em quais páginas o banner deve aparecer <span style={{ color: 'red' }}>*</span>
                    </FormLabel>
                    <FormLabel mb="8px">
                      Ordem de exibição <span style={{ color: 'red' }}>*</span>
                      <Tooltip label="Ordem a ser utilizada para exibir o banner nas páginas." aria-label="A informação da ordem de exibição">
                        <IconButton
                          className='icones'
                          variant='link'
                          icon={<MdInfoOutline />}
                          aria-label="Informação"
                          size="md"
                          color={'#2883de'} />
                      </Tooltip>
                    </FormLabel>
                  </Flex>

                  <div className="sidebar-checkbox-pagina">
                    <Stack spacing={5}>
                      {paginas.length > 0 ? (
                        paginas.map((pagina) => {
                          const inputRef = React.createRef<HTMLInputElement>();
                          return (<Flex
                            key={pagina.seqPagina}
                            align="center"
                            justify="space-between"
                            direction={{ base: 'column', md: 'row' }}
                          >
                            <Checkbox
                              disabled={true}
                              sx={{
                                '.chakra-checkbox__label': {
                                  opacity: 1,
                                  userSelect: 'none',
                                },
                              }}
                              className="checkPaginasNoticia"
                              isChecked={formValues.paginaId.value.includes(pagina.seqPagina)}
                            >
                              {pagina.nomPagina}
                            </Checkbox>

                            <div>
                              <CustomInput
                                isDisabled={true}
                                className="input-ordem-aprova opacidade"
                                isReadOnly={!formValues.paginaId.value.includes(pagina.seqPagina)}
                                value={(() => {
                                  const ordemItem = formValues.ordemBanner.value.find(
                                    (item: any) => item.seqPagina === pagina.seqPagina
                                  );
                                  return ordemItem ? ordemItem.numOrdem : '';
                                })()}
                                placeholder="Ordem"
                                ref={inputRef}
                              />
                            </div>
                          </Flex>
                          )
                        })
                      ) : (
                        <p>Não há páginas disponíveis.</p>
                      )}
                    </Stack>
                  </div>
                </FormControl>

              </div>
              <div className="col-md-6 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Crédito/Autor da imagem</FormLabel>
                  <CustomInput
                    isDisabled={true}
                    className='opacidade'
                    value={formValues.creditoAutorImagem.value}
                  />
                </FormControl>

                <div className="row" style={{ marginTop: '24px' }}>
                  <div className={`mb-4 col-md-${formValues.exigeAprovacao.value === 1 ? '4' : '6'}`}>
                    <FormControl isRequired>
                      <FormLabel mb="8px">Exige aprovação</FormLabel>
                      <RadioGroup
                        isDisabled={true}
                        className='opacidade'
                        mt={3.5}
                        value={formValues.exigeAprovacao.value.toString()}
                      >
                        <Radio value="1" mr={5}>Sim</Radio>
                        <Radio value="0">Não</Radio>
                      </RadioGroup>
                    </FormControl>
                  </div>

                  {formValues.exigeAprovacao.value === 1 && (
                    <div className="col-md-8 mb-4">
                      <FormControl isRequired>
                        <FormLabel mb="8px">Selecione o aprovador desta publicação</FormLabel>
                        <div className={`input-radio-lista ${aprovadores.length === 0 ? 'escondida' : ''}`}>
                          <Stack spacing={5}>
                            {aprovadores.length > 0 ? (
                              aprovadores.map((aprovador: any) => (
                                <Flex key={aprovador.seqUsuario} align="center" justify="space-between" direction="row">
                                  <Radio
                                    isDisabled={true}
                                    className="opacidade radioAprovadoresNoticia"
                                    value={aprovador.seqUsuario.toString()}
                                    isChecked={selectedUser === aprovador.seqUsuario}
                                  >
                                    {aprovador.dscNome}
                                  </Radio>
                                </Flex>
                              ))
                            ) : (
                              <p>Não há lista de aprovadores disponíveis.</p>
                            )}
                          </Stack>
                        </div>
                      </FormControl>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <Flex justifyContent="end">
              <Button
                m="6px"
                onClick={handleReprovarPublicacao}
                isDisabled={executor != seqUsuario}
                isLoading={isReprovandoButton}
                loadingText="Reprovando Publicação..."
              >
                Reprovar Publicação
              </Button>
              <Button
                type="submit"
                m="6px"
                color="#FFF"
                bgColor="#1665D8"
                _hover={{ opacity: 0.8 }}
                isDisabled={executor != seqUsuario}
                isLoading={isAprovandoButton}
                loadingText="Aprovando Publicação..."
              >
                Aprovar Publicação
              </Button>
            </Flex>
            <Flex hidden={executor == seqUsuario} justifyContent="end">
              <p className='mansagem-erro-executor'>
                Você não é o aprovador desta publicação.
              </p>
            </Flex>
          </form>
        </Box>
      )}

      <Modal show={isErrorModalOpen} onHide={() => setIsErrorModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setIsErrorModalOpen(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Flex>
  );
};

export default AprovarBanner;
